import { render, staticRenderFns } from "./PigeonFormModal.vue?vue&type=template&id=aa45b670&scoped=true&"
import script from "./PigeonFormModal.vue?vue&type=script&lang=js&"
export * from "./PigeonFormModal.vue?vue&type=script&lang=js&"
import style0 from "./PigeonFormModal.vue?vue&type=style&index=0&id=aa45b670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa45b670",
  null
  
)

export default component.exports